// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__17cPh","colMin":"styles_colMin__30wND","colCheckbox":"styles_colCheckbox__1wuCV"};